import Vue from 'vue';
import flatpickr from 'flatpickr';
import { Russian } from 'flatpickr/dist/l10n/ru';
import VueCurrencyFilter from 'vue-currency-filter';
import vuexI18n from 'vuex-i18n';
import { translationsEn, translationsRu } from '@/i18n/index';
import store from './store/store';

flatpickr.localize(Russian);

// Localisation
Vue.use(vuexI18n.plugin, store);
Vue.i18n.add('en', translationsEn);
Vue.i18n.add('ru', translationsRu);
Vue.i18n.set('ru');

Vue.use(VueCurrencyFilter, {
  symbol: 'руб.',
  thousandsSeparator: ' ',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'back',
  symbolSpacing: true
});
